export const getDesktopStyle = () => {
    return {top : '41px', left : '64px', right : '0', width : '100%', maxWidth: 'calc(100vw - 64px)', minWidth: 'calc(100vw - 64px)', minHeight : 'auto'}
};